import classNames from 'classnames'

import { ProfileDefaultImage } from '@local/assets/images'

import Image from '@web/components/Image'
import useMe from '@web/hooks/useMe'

import styles from '../../MissionCard/Content/ProgressStamp/ProgressStamp.module.scss'
import { MissionCardProps } from '../../MissionCard/MissionCard'

interface Props {
  disabled?: boolean
  missionCard: MissionCardProps
}

const ProfileBorderStamp = ({ missionCard, disabled = false }: Props) => {
  const { me } = useMe()
  const isBunnyBorder = missionCard.reward.name === '프로필 검은 토끼 띠'

  return (
    <div className={classNames(styles.profile, { [styles.disabled]: disabled })}>
      <Image
        src={me?.profile?.imageUrl ?? ProfileDefaultImage}
        className={styles.img}
        width={46}
        height={46}
        alt="프로필"
      />
      {/* 23년 1월인 경우 type_2301 클래스 추가 */}
      <Image
        className={classNames(styles.img_decorate, { [styles.type_2301]: isBunnyBorder })}
        src={missionCard.reward.imageUrl ?? ''}
        width="100%"
        height="100%"
        alt="계묘년 토끼 프로필 꾸미기 띠"
      />
    </div>
  )
}

export default ProfileBorderStamp
